import SessionMetaData from './SessionMetaData';

export default SessionMetaData;
